import React, { useState, useEffect } from "react";
//import AddNewPipelineModal from "./AddNewPipelineModal";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CgNotes } from "react-icons/cg";
import { AiOutlineEye } from "react-icons/ai";
import { IoHomeOutline } from "react-icons/io5";
import { GrDocumentSound } from "react-icons/gr";
import { IoIosLink } from "react-icons/io"; 
import { TbUsersGroup } from "react-icons/tb";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import the CSS
import "./Allpipeline.css";
import { useSelector,useDispatch } from "react-redux";
import { superAdminAction,userId,superAdminSelector } from "../../redux/reducers/superAdminReducer";
import logo from "../Public/logo.png";
import { FaUserCircle, FaRocket } from "react-icons/fa";
import ENDPOINT_URL from "../../config";
const Allpipeline = () => {
  const [pipelines, setPipelines] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState({ name: "", email: "" });
  const [applicationCounts, setApplicationCounts] = useState({}); // Store counts for each pipeline
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation hook to get the location object
  const dispatch=useDispatch();
  const role=useSelector(superAdminSelector);
  const getUserId=useSelector(userId);

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
     // console.log('Running*******************')
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          // "https://incubator.drishticps.org/api/superadmins/me",
            `${ENDPOINT_URL}/api/superadmins/me`,
          {
            withCredentials:true
          }
        );
        setUser(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    if(getUserId){
   //   console.log('Running*******************')
      if(role=='Super Admin' ){
        fetchUserData();
      }else if(role=='Admin'){
        navigate('/admincards')
      }else{
        navigate('/homepage')
      }
    }else{
      navigate('/login')
    }  
  }, []);
 

//To fetch all pipelines for super admin.
    useEffect(() => {
        handleAllPipelines();
    }, []);

    const handleAllPipelines = async() => {
      try{
        console.log("Fetching all pipelines...");
        // const response = await axios.get(
        //   "https://incubator.drishticps.org/api/pipelines/pipeline/all-pipelines",{withCredentials: true});
        const response = await axios.get(
          `${ENDPOINT_URL}/api/pipelines/pipeline/all-pipelines`,
          { withCredentials: true }
        );
       // console.log("All Pipelines length:", response.data.length);
        setPipelines(response.data);
        console.log("Program manager", response.data);
        response.data.forEach(async (pipeline) => {
            try {
              // Fetch the count of form submissions for each specific pipeline and form
            /*  const countResponse = await axios.get(
                `https://incubator.drishticps.org/api/forms/pipeline/${pipeline._id}/form/${pipeline.forms}/responses/count`,{withCredentials:true}
              );*/
              const countResponse = await Promise.all(
                pipeline.rounds.map((round) => {
                  if (round.application && round.application.formId) {
                    return axios.get(
    // `https://incubator.drishticps.org/api/forms/pipeline/${pipeline._id}/form/${round.application.formId}/responses/count`,
                        `${ENDPOINT_URL}/api/forms/pipeline/${pipeline._id}/form/${round.application.formId}/responses/count`,
                      { withCredentials: true }
                    );
                  }
                  return null; // Skip rounds without a formId
                })
              );
             // console.log('******resp:',countResponse);
  
                if (Array.isArray(countResponse) && countResponse[0]?.data) {
                  const count = countResponse[0].data.count ?? 0; // Use 0 if count is undefined or 0
                  setApplicationCounts((prevCounts) => ({
                    ...prevCounts,
                    [pipeline._id]: count,   
                  }));
                } else {
                  console.error("countResponse is not in expected array format or missing data property:", countResponse);
                  setApplicationCounts((prevCounts) => ({
                    ...prevCounts,
                    [pipeline._id]: 0, // Set to 0 if countResponse is not in expected format
                  }));
                }
                
            } catch (countError) {
              console.error("Error fetching submission count", countError);
            }
          });
        
      }catch(err){
        console.error(err );
      }
    }
  

const handleLogout = async () => {
  //  localStorage.removeItem("token");
  const response = await axios.post(
// "https://incubator.drishticps.org/api/logout/superAdmin",
      `${ENDPOINT_URL}/api/logout/superAdmin`,
    {},
    { withCredentials: true }
  );setUser(null);
  dispatch(superAdminAction.logoutUser());
    navigate("/login");
  
  };
  const handleNavigation = (route, state) => {
    if (route === "/homepage") {
      navigate(route);

    } else {
      console.log("Else block",route);
      navigate(route, { state });
    }
  };

  return (
    <div className="dashboard-homepage-pipeline">
      <aside className="card-sidebar">
            <div className="card-logo-container">
               <div className="card-logo" onClick={() => handleNavigation("/cards")}>
            <img style={{width:"90px", marginRight:"70px"}} src={logo} alt="Logo" />
                        </div>
            </div>
            <div className="card-nav-container">
              <nav className="card-nav">
                <ul>
                  <li
                    className="card-nav-item"
                    style={{ marginTop: "0px", width: "240px" }}
                    onClick={() =>
                      handleNavigation("/SuperadminDash", { showActive: true })
                    }
                  >
                    <FaUserCircle className="card-nav-icon" /> Organization
                  </li>
    
                  <li
                    className="card-nav-item"
                    onClick={() =>
                      handleNavigation("/admindash", {
                        showActive: true,
                        allProgramManagers: true,
                      })
                    }
                  >
                    <FaRocket className="card-nav-icon" /> Program Manager
                  </li>
                  <li
                    className="card-nav-item"
                    onClick={() => handleNavigation("/all-pipelines")}
                  >
                    <FaRocket className="card-nav-icon" />Pipelines
                  </li>
                </ul>
              </nav>
            </div>
          </aside>
      <main className="main-content-homepage-pipeline">
        <header className="header-homepage-pipeline">
          <span className="founder-homepage-pipeline">All Pipelines</span>
          <div className="profile-section-homepage-pipeline">
            <div className="user-info-homepage-pipeline">
              <span className="user-initials-homepage-pipeline">
                <img
                  src="/navbar/login.png"
                  alt="Login"
                  style={{ width: "40px" }}
                />
              </span>
              <div className="user-details-homepage-pipeline">
                <span >
                  {user.name}
                </span>
                <br />
               
              </div>
            </div>
            <button
              className="logout-button-homepage-pipeline"
              onClick={handleLogout}
              style={{ marginLeft: "20px", padding: "8px" }}
            >
              Logout
            </button>
          </div>
        </header>
        <section className="content-homepage-pipeline">
                   {pipelines.length === 0 ? (
            <div>No Pipeline added yet</div>
          ) : (
            <div className="pipelines-list-pipeline">
              {pipelines.map((pipeline, index) => (
                <div className="pipeline-card-pipeline" key={index}>
                  <h4 className="pipeline-name-pipeline">{pipeline.title}</h4>
                  <div className="pipeline-stats-pipeline">
                  <p style={{ fontWeight: "500", color: "#007bff" }}>
  Program Manager: {pipeline.programManager?.username || "N/A"}
</p>

                    <p style={{ marginTop: "8px" }}>Program: {pipeline.program}</p>
                    <p>Cohort: {pipeline.cohort}</p>
                    <p>Type: {pipeline.type}</p>
                    <div className="bottom-section">                
                    <div className="count-pipeline">
                      {/* Display total applications under this pipeline*/}
                      <button className="view-application-pipeline33">
                        <Link
                        to={{
                          pathname: `/all-applications`,
                          state: {
                            pipelineId: pipeline._id,
                            formId:pipeline.rounds.map((round) => round.application?.formId),
                            title: pipeline.title, // *** START CHANGE for passing pipeline title ***
                          }, // Pass pipelineId and formId correctly
                        }}
                        state={{
                          pipelineId: pipeline._id,
                          formId: pipeline.rounds.map((round) => round.application?.formId),
                          title: pipeline.title, // Ensure the title is passed
                        }}
                        className="count-pipeline33" // Ensure the state is passed outside the 'to' prop as well
                      >
                        <p>
                          View Applications:{" "}
                          {applicationCounts[pipeline._id] !== undefined
                            ? applicationCounts[pipeline._id]
                            : "Loading..."}
                        </p>
                          </Link>
                          </button>
                    </div>
                  </div>
                  
                </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </main>
     
    </div>
  );
};

export default Allpipeline;
  




